import React, { useState } from 'react';

import usePowerlist from '../../hooks/usePowerlist';
import { PowerlistPersonData } from '../../utils/backend-api/powerlist';
import PowerlistHeader from '../Powerlist/PowerlistHeader';
import PowerlistSection from '../Powerlist/PowerlistSection';
import styles from './styles.module.scss';

export interface PowerlistPersonDetails extends PowerlistPersonData {
  rowNum: string;
}

const Layout = () => {
  const [details, setDetails] = useState<PowerlistPersonDetails>(null);

  const handlePersonClick = (person, rowNum) => {
    setDetails({ ...person, rowNum });

    // track ahoy click event
    // @ts-expect-error todo: import ahoy instead of using global
    ahoy.start();
    // @ts-expect-error todo: import ahoy instead of using global
    ahoy.track('enterprise-powerlist-profile-click', {
      person: person.name,
      // @ts-expect-error todo: switch to useCurrentUser
      user_id: currentUser.id,
      // @ts-expect-error todo: switch to useCurrentUser
      email: currentUser.email,
      page: window.location.pathname,
    });
  };

  const handleClose = () => {
    setDetails(null);
  };

  const { data, isLoadingPowerlist } = usePowerlist('enterprise');

  return (
    <>
      {!isLoadingPowerlist && (
        <>
          <PowerlistHeader />
          <div className="container-fluid operators" id={styles.operatorsSection}>
            {data?.executives && (
              <PowerlistSection
                details={details}
                handleClose={handleClose}
                handlePersonClick={handlePersonClick}
                section={data.executives}
                sectionNum={1}
                title={'Executives'}
              />
            )}
          </div>
          <div className="container-fluid investors" id={styles.investorsSection}>
            {data?.investors && (
              <PowerlistSection
                details={details}
                handleClose={handleClose}
                handlePersonClick={handlePersonClick}
                section={data.investors}
                sectionNum={2}
                title={'Investors'}
              />
            )}
          </div>
          <div className="container-fluid emerging" id={styles.emergingSection}>
            {data?.emerging && (
              <PowerlistSection
                details={details}
                handleClose={handleClose}
                handlePersonClick={handlePersonClick}
                section={data.emerging}
                sectionNum={3}
                title={'Up & Comers'}
              />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Layout;
